// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"matrixSelect_wrapper__2jcBe","item":"matrixSelect_item__2A-1A","titleRow":"matrixSelect_titleRow__UTI_R"};